import { Injectable } from '@angular/core';
import { Query } from '@examdojo/state';
import { Observable } from 'rxjs';
import { Currency, CurrencyStoreState } from './currency.model';
import { CurrencyStore } from './currency.store';

@Injectable({ providedIn: 'root' })
export class CurrencyQuery extends Query<CurrencyStoreState> {
  constructor(currencyStore: CurrencyStore) {
    super(currencyStore);
  }

  selectCurrencies(): Observable<Currency[]> {
    return this.select('currencies');
  }

  selectLoading(): Observable<boolean> {
    return this.select('loading');
  }

  getCurrencies(): Currency[] {
    return this.getValue().currencies;
  }

  isLoading(): boolean {
    return this.getValue().loading;
  }
}
